// @ts-nocheck
import React, { useRef, useState, useReducer, useEffect } from 'react';
import {
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Icon,
	IconButton,
	Link,
	ListItem,
	TextField,
} from '@mui/material';
import '../../styles/ChatTagsList.css';
import { getHubURL } from '@src/helpers/URLHelper';
import { useTranslation } from 'react-i18next';
import { AppConfig } from '@src/contexts/AppConfig';
import { setFilterTag } from '@src/store/reducers/filterTagReducer';
import { useAppDispatch, useAppSelector } from '@src/store/hooks';
import SellIcon from '@mui/icons-material/Sell';
import { ColorPicker, Color } from 'material-ui-color';
import CustomTagField from './Sidebar/CustomTagField';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteIcon from '@mui/icons-material/Delete';
import { ApplicationContext } from '@src/contexts/ApplicationContext';

function ManageTags(props) {
	const { apiService }: any = React.useContext(ApplicationContext);
	const config = React.useContext(AppConfig);
	const tags = useAppSelector((state) => state.tags.value);
	const [allTags, setAllTags] = useState(tags);

	const { t } = useTranslation();

	const [isLoading, setLoading] = useState(false);

	const dispatch = useAppDispatch();

	const editTag = (tagId) => {
		const updatedTagsArray = allTags?.map((tag) => {
			if (tag?.id === tagId) {
				return { ...tag, editView: true };
			}
			return tag;
		});
		setAllTags(updatedTagsArray);
	};

	const deleteTag = (tagId) => {
		apiService.deleteTagV2(tagId, () => {
			props?.listTags();

			const data = allTags?.filter((tag) => tag?.id !== tagId);
			setAllTags(data);
		});
	};

	const close = () => {
		props.setOpen(false);
	};

	return (
		<Dialog open={props.open} onClose={close}>
			<DialogTitle>{t('Manage Tags')}</DialogTitle>
			<DialogContent className="chatTagsListWrapper">
				<div style={{ display: 'flex', flexDirection: 'flex-end' }}>
					<CustomTagField
						operation="create"
						allTags={allTags}
						setAllTags={setAllTags}
						listTags={props?.listTags}
					/>
				</div>
				{allTags && (
					<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
						{allTags.length > 0 ? (
							<div style={{ width: '100%' }}>
								{allTags.map((tag) =>
									tag?.editView ? (
										<CustomTagField
											operation="update"
											allTags={allTags}
											setAllTags={setAllTags}
											editableTag={tag}
											listTags={props?.listTags}
										/>
									) : (
										<ListItem key={tag.id}>
											<div
												style={{
													display: 'flex',
													justifyContent: 'space-between',
													alignItems: 'center',
													width: '350px',
												}}
											>
												<div className="chatTagsListWrapper__tag">
													<SellIcon
														style={{
															fill: tag.web_inbox_color,
														}}
													/>
													{tag.name}
												</div>
												<div>
													<IconButton onClick={() => editTag(tag?.id)} size="medium">
														<ModeEditIcon />
													</IconButton>
													<IconButton onClick={() => deleteTag(tag?.id)} size="medium">
														<DeleteIcon />
													</IconButton>
												</div>
											</div>
										</ListItem>
									)
								)}
							</div>
						) : (
							<div className="chatTagsList__empty">{t('Empty')}</div>
						)}
					</div>
				)}
				<div className="mt-3">
					{/* <Link
						href={getHubURL(config.TEST.API_BASE_URL) + 'main/tag/'}
						target="_blank"
						underline="hover"
					>
						{t('Manage tags')}
					</Link> */}
				</div>
			</DialogContent>
			<DialogActions>
				<Button onClick={close} color="secondary">
					{t('Close')}
				</Button>
			</DialogActions>

			{isLoading && (
				<div className="chatTagsListWrapper__loading">
					<CircularProgress size={28} />
				</div>
			)}
		</Dialog>
	);
}

export default ManageTags;
